<template>
  <div>
    <div class="step-header">
      <small>Etapa 1 de 5</small>
      <h5>Informações pessoais</h5>
      <small>Atenção: TODOS os campos são obrigatórios.</small>
    </div>

    <b-form-group class="w-100 mt-0">
      <input
        type="text"
        :value="nome"
        required="required"
        v-on:change="updateValue($event, 'nome')"
      />
      <label for="input" class="control-label" style="font-size: 90%;">Nome*</label>
      <i class="bar"></i>
    </b-form-group>
    <b-form-group class="w-100 mt-1">
      <input
        type="text"
        v-model="cpf"
        v-mask="'###.###.###-##'"
        required="required"
        v-on:change="updateValue($event, 'cpf')"
      />
      <label for="input" class="control-label" style="font-size: 90%;">CPF*</label>
      <i class="bar"></i>
    </b-form-group>
    <b-form-group class="w-100 mt-1">
      <input type="number" :value="rg" required="required" v-on:change="updateValue($event, 'rg')" />
      <label for="input" class="control-label" style="font-size: 90%;">RG*</label>
      <i class="bar"></i>
    </b-form-group>

    <b-form-group class="w-100 mt-1">
      <input
        type="date"
        :value="birthdate"
        required="required"
        v-on:change="updateValue($event, 'birthdate')"
      />
      <label for="input" class="control-label" style="font-size: 90%;">Data de nascimento*</label>
      <i class="bar"></i>
    </b-form-group>

    <b-form-group class="w-100 mt-1">
      <input
        type="email"
        :value="email"
        required="required"
        v-on:change="updateValue($event, 'email')"
      />
      <label for="input" class="control-label" style="font-size: 90%;">E-mail*</label>
      <i class="bar"></i>
    </b-form-group>

    <b-form-group class="w-100 mt-1">
      <input
        type="tel"
        v-model="celular"
        v-mask="'(##) # ####-####'"
        required="required"
        v-on:change="updateValue($event, 'celular')"
      />
      <label for="input" class="control-label" style="font-size: 90%;">Celular*</label>
      <i class="bar"></i>
    </b-form-group>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { VueMaskDirective } from "v-mask";

export default {
  directives: {
    mask: VueMaskDirective
  },

  props: ["nome", "cpf", "rg", "birthdate", "email", "celular"],
  methods: {
    updateValue(event, data) {
      this.$emit(`update:${data}`, event.target.value);
    }
  }
};
</script>

<style lang="scss" scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}

.step-header {
  margin-bottom: 30px;
}
</style>
